import { useEffect } from 'react';

import { useGetSelectProjects } from 'hooks/api/general/useGetSelectProjects';

import { useAppContext } from 'store/AppProvider';

/**
 * useSetProjectsToStore is a custom hooks that fetches the projects list and sets it to the store
 */
const useSetProjectsToStore = () => {
    const { setProjectsList } = useAppContext();

    const { data: projectsData, isFetched, refetch } = useGetSelectProjects();

    useEffect(() => {
        if (projectsData && projectsData.length > 0) {
            setProjectsList(projectsData);
        }
    }, [projectsData]);

    return { isFetched, fetchProjects: refetch };
};

export default useSetProjectsToStore;
